var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-logo flex align-center",class:( _obj = {'nav-collapsed':_vm.collapseNav}, _obj[_vm.mode] = true, _obj )},[_c('img',{staticClass:"image-logo",attrs:{"src":require("@/assets/images/logo.png"),"alt":"logo"},on:{"click":function($event){_vm.goto('/')}}}),_c('button',{staticClass:"collapse-nav",on:{"click":_vm.collapseNavToggle}},[_c('i',{staticClass:"mdi mdi-menu"})])])
var _obj;}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51beb9ec","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/logo.vue
// module id = null
// module chunks = 